import { gsap } from "gsap";

class Timeline {
  constructor(timeline) {
    this.timeline = timeline.querySelector(".timeline");
    this.liveRegion = timeline.querySelector("div[role=region]");
    this.timelineItems = timeline.querySelectorAll(".timeline-card");
    this.numberOfItems = this.timelineItems.length;
    this.rangeSteps = 100 / (this.numberOfItems - 1);
    this.prevButton = timeline.querySelector(".timeline-prev");
    this.nextButton = timeline.querySelector(".timeline-next");
    this.inputRange = timeline.querySelector(".timeline-range");
    this.startYear = timeline.querySelector(".timeline-start-year");
    this.endYear = timeline.querySelector(".timeline-end-year");
    this.activeItem = this.numberOfItems - 1;
    this.inputRange.setAttribute("step", this.rangeSteps);
    this.animationTimeline = this.buildAnimation();

    const allowScrollWithoutPropogation = (e) => e.stopPropagation();
    this.inputRange?.addEventListener('touchmove', allowScrollWithoutPropogation, { passive: false });

    const years = [];
    this.timelineItems.forEach((item, index) => {
      const year = parseInt(item.querySelector(".timeline-card__year").textContent);
      years.push(year);
    });
    years.sort((a, b) => a - b);

    this.startYear.textContent = years[0];
    this.endYear.textContent = years[years.length - 1];

    this.prevButton.addEventListener("click", () => this.prev());
    this.nextButton.addEventListener("click", () => this.next());
    this.inputRange.addEventListener("input", () => this.rangeInput());
    // this.inputRange.addEventListener("change", () => this.rangeChange());

    this.update();
  }

  next() {
    this.activeItem++;
    this.update();
    this.notifySlideChange(this.activeItem);
  }

  prev() {
    this.activeItem--;
    this.update();
    this.notifySlideChange(this.activeItem);
  }

  rangeInput() {
    const value = this.inputRange.value;
    const index = Math.round(value / this.rangeSteps);

    this.activeItem = index;
    this.update();
  }

  rangeChange() {
    const value = this.inputRange.value;
    const index = Math.round(value / this.rangeSteps);
    this.notifySlideChange(index);
  }

  notifySlideChange(index) {
    const message = `Slide ${index + 1} of ${this.numberOfItems}`;
    this.liveRegion.textContent = message;
  }

  update() {
    this.timelineItems.forEach((item, index) => {
      const image = item.querySelector("img.image-ring");
      if (index === this.activeItem) {
        item.classList.add("active");
        if (!image.classList.contains("rotate-circle-intersection")) {
          image.classList.add("rotate-ring");
        }
        item.removeAttribute("aria-hidden");
        item.removeAttribute("tabindex");
      } else {
        item.classList.remove("active");
        image.classList.remove("rotate-ring");
        image.classList.remove("rotate-circle-intersection");
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });

    this.inputRange.value = this.activeItem * this.rangeSteps;

    this.prevButton.disabled = this.activeItem === 0;
    this.nextButton.disabled = this.activeItem === this.timelineItems.length - 1;

    const progress = this.activeItem * this.rangeSteps / 100;
    this.animationTimeline.progress(progress);
  }

  buildAnimation() {
    const timeline = gsap.timeline({
      paused: true,
      defaults: {duration: 2, scale: 1.1, y: 70, opacity: 0, ease: "linear"}
    });

    //check for reduced motion
    const isReduced = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;

    const steps = this.numberOfItems - 1;

    for (let step = 0; step < steps; step++) {
      let label = ">";

      this.timelineItems.forEach((item, index) => {
        if (index >= step + 2 ) {
          timeline.to(item, {scale: isReduced ? 1 : 1.1, y: isReduced ? 0 : 70, opacity: 0}, label);
          label = "<";
        }
        else if (index === step + 1) {
          timeline.to(item, {scale: 1, y: 0, opacity: 1}, label);
          label = "<";
        }
        else if (index === step) {
          timeline.to(item, {scale: isReduced ? 1 : 0.9, y: isReduced ? 0 : -70, opacity: 1}, label);
          label = "<";
        }
        else if (index === step - 1) {
          timeline.to(item, {scale: isReduced ? 1 : 0.8, y: isReduced ? 0 : -140, opacity: 1}, label);
          label = "<";
        }
        else if (index <= step - 2) {
          timeline.to(item, {scale: isReduced ? 1 : 0.7, y: isReduced ? 0 : -210, opacity: 0}, label);
          label = "<";
        }
      });
    }

    return timeline;
  }
}

document.querySelectorAll(".timeline-default").forEach(timelineSection => {
  new Timeline(timelineSection);
});